import { apiClient } from './apiClient';

class UploadAPI {
  uploadImage(formData) {
    return apiClient.upload('/images', formData);
  }
}
export const uploadAPI = new UploadAPI();



// WEBPACK FOOTER //
// ./src/InterfaceAPI/uploadAPI.js